import { classNames } from "primereact/utils";
import styles from "./EventNameFilterTabs.module.scss";

interface IEventNameFilterTabsProps {
  eventNames: string[];
  selectedName: string | null;
  onSelect: (name: string | null) => void;
}

export const EventNameFilterTabs = ({
  eventNames,
  selectedName,
  onSelect,
}: IEventNameFilterTabsProps) => {
  if (eventNames.length <= 1) return null;

  return (
    <div className={styles.root}>
      <button
        className={classNames(styles.tab, {
          [styles.tab_active]: selectedName === null,
        })}
        onClick={() => onSelect(null)}
        type="button"
      >
        Всички
      </button>
      {eventNames.map((name) => (
        <button
          key={name}
          className={classNames(styles.tab, {
            [styles.tab_active]:
              selectedName?.toLowerCase() === name.toLowerCase(),
          })}
          onClick={() => onSelect(name)}
          type="button"
        >
          {name}
        </button>
      ))}
    </div>
  );
};
